import { render, staticRenderFns } from "./order_assign_all.vue?vue&type=template&id=772c4fb5&scoped=true"
import script from "./order_assign_all.vue?vue&type=script&lang=js"
export * from "./order_assign_all.vue?vue&type=script&lang=js"
import style0 from "./order_assign_all.vue?vue&type=style&index=0&id=772c4fb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c4fb5",
  null
  
)

export default component.exports